
export function GameScenario() {
	return (
		<div className="flex w-fit pointer-events-none">
			<div className="item-carrosel animation-background">
				<img className="h-full w-full object-fill" src="./assets/cenario/fundo.png" alt="Cenario de fundo" />
			</div>
			<div className="item-carrosel animation-background">
				<img className="h-full w-full object-fill" src="./assets/cenario/fundo.png" alt="Cenario de fundo" />
			</div>
			<div className="item-carrosel animation-background">
				<img className="h-full w-full object-fill" src="./assets/cenario/fundo.png" alt="Cenario de fundo" />
			</div>
			<div className="item-carrosel animation-background">
				<img className="h-full w-full object-fill" src="./assets/cenario/fundo.png" alt="Cenario de fundo" />
			</div>
		</div>
	)
}
